import { Box } from "@mui/material";
import { type FC } from "react";
import { PaginationWrapper } from "../generic/components/pagination-wrapper";
import { AssetCard } from "./asset-card";
import type { Asset } from "./server/digital-asset-service";

export const AssetGrid: FC<{
  assets: Asset[];
  designer?: string | null;
  onClick?: (asset: Asset) => void;
}> = ({ assets, designer, onClick }) => {
  return (
    <PaginationWrapper
      data={assets}
      itemsPerPage={25}
      renderPage={(data) => (
        <Box display="grid" gap={4} gridTemplateColumns="repeat(auto-fit, minmax(200px, 305px))">
          {data.map((asset) => (
            <AssetCard
              key={asset.id}
              asset={asset}
              data-testid="asset"
              onClick={() => onClick?.(asset)}
              designer={designer}
            />
          ))}
        </Box>
      )}
    />
  );
};
